<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-5 mx-0 no-gutter">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <mq-series-configuration-form v-model="config" :readonly="!editMode" :mode="mode"></mq-series-configuration-form>
      <b-row class="justify-content-end mt-3 no-gutters">
          <b-button v-if="mode === 'create'"
          @click="createConfig" variant="primary">
            <i class="fa-light fa-save"></i>
            <span>{{$t('common.sve')}}</span>
          </b-button>
          <b-button v-if="mode === 'details' && editMode === false && canEditConfig" class="mr-3"
          @click="editModeActivate" variant="primary">
            <span>{{$t('common.routing.edit_this_config')}}</span>
          </b-button>
          <b-button v-if="mode === 'details' && editMode === false && canDeleteConfig"
          @click="deleteConfig" variant="primary">
            <i class="fa-light fa-trash"></i>
            <span>{{$t('common.routing.delete_config')}}</span>
          </b-button>
          <b-button variant="primary" v-if="mode === 'details' && editMode === true"
            @click="editConfig">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import MQSeriesConfigurationForm from '@/pages/routing/MQSeriesConfigurationForm.vue'

import {loadPage} from '@/helpers/routing'

export default {
  name: 'MessageDetails',
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'mq-series-configuration-form': MQSeriesConfigurationForm,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "create"
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.rights.rightIs('mqseriesConfig_supprimer', true)
    },
    canEditConfig () {
      return this.$engine.rights.rightIs('mqseriesConfig_editer', true)
    },
    pageTitle () {
      return this.mode === "details" ? this.$t('Webheader.mqseries_details') : this.$t('Webheader.mqseries_add')
    },
  },
  data () {
    return {
      activateSpinner: false,
      config: {},
      editMode: false,
      returnUrl: '/routing/configurationList/MQSERIES',
      savedConfig: []
    }
  },
  created () {
    this.activateSpinner = true
    if (this.mode === "details") {
      this.savedConfig = this.$engine.routing.config.clickedConfig
      this.fillFields()
      this.$engine.routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    createConfig () {
      let that = this

      if (this.formHasError()) { 
        return
      }

      if (this.config.sslActive === "1") { 
        let paramsControl = {
          selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: this.config.certificateConfig.type,
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          commonName: this.config.certificateConfig.cn,
          idPod: this.config.certificateConfig.idPod
        }

        this.$engine.security.certificates.create(paramsCertif)
        .then(respCertificate => {
            let paramsPrivateKey = {
            name: this.config.privateKeysConfig.name,
            privateKey: this.config.privateKeysConfig.privateKey,
            password: this.config.privateKeysConfig.password,
            passwordVerif: this.config.privateKeysConfig.passwordVerif,
            type: this.config.privateKeysConfig.type,
            idPod: this.config.privateKeysConfig.idPod
          }
          let params = {
            idCertificat: respCertificate.data.idCertificat
          }

          this.$engine.security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            params.ChannelName = this.config.channelName,
            params.ConnectionMode = this.config.connectionMode,
            params.ConnectionType = this.config.connectionType,
            params.Host = this.config.host,
            params.Name = this.config.name,
            params.Port = this.config.port,
            params.QueueManager = this.config.queueManager,
            params.QueueName = this.config.queueName,
            params.SSL = this.config.sslActive,
            params.idPrivateKey = respPrivateKey.data.idPrivateKey 
            this.$engine.routing.config.mqseries.create(params) 
            .then(resp => {
              that.$f7.modal({
                title: that.$t('common.routing.config_added'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: '/routing/configurationList/MQSERIES'})
            })
          })
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      } else {
        let params = {
          ChannelName: this.config.channelName,
          ConnectionMode: this.config.connectionMode,
          ConnectionType: this.config.connectionType,
          Host: this.config.host,
          Name: this.config.name,
          Port: this.config.port,
          QueueManager: this.config.queueManager,
          QueueName: this.config.queueName,
          SSL: this.config.sslActive
          //idCertificate: respCertificate.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          //idPrivateKey: respPrivateKey.data.id
        }
        this.$engine.routing.config.mqseries.create(params) 
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_added'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/routing/configurationList/MQSERIES'})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      }
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdMQSeries: that.savedConfig.IdMQSeries
              }
              that.$engine.routing.config.mqseries.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: '/routing/configurationList/MQSERIES'})
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let that = this

      if (this.formHasError()) {  
        return
      }
      
      if (this.config.sslActive === "1") {
        let paramsControl = {
        selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: this.config.certificateConfig.type,
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          commonName: this.config.certificateConfig.cn
          //idCertificate: this.savedConfig.idCertificate DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
        }
        this.$engine.security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: this.config.privateKeysConfig.name,
            privateKey: this.config.privateKeysConfig.privateKey,
            password: this.config.privateKeysConfig.password,
            passwordVerif: this.config.privateKeysConfig.passwordVerif,
            type: this.config.privateKeysConfig.type
            //idPrivateKey: respPrivateKey.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          }
          this.$engine.security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            let params = {
              ChannelName: this.config.channelName,
              ConnectionMode: this.config.connectionMode,
              ConnectionType: this.config.connectionType,
              Host: this.config.host,
              IdMQSeries: this.savedConfig.IdMQSeries,
              Name: this.config.name,
              Port: this.config.port,
              QueueManager: this.config.queueManager,
              QueueName: this.config.queueName,
              SSL: this.config.sslActive
            }
            this.$engine.routing.config.mqseries.edit(params)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('common.routing.config_edited'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: '/routing/configurationList/MQSERIES'})
            })
          })
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_edition_error'))
        })
      } else {
        let params = {
          ChannelName: this.config.channelName,
          ConnectionMode: this.config.connectionMode,
          ConnectionType: this.config.connectionType,
          Host: this.config.host,
          IdMQSeries: this.savedConfig.IdMQSeries,
          Name: this.config.name,
          Port: this.config.port,
          QueueManager: this.config.queueManager,
          QueueName: this.config.queueName,
          SSL: this.config.sslActive
        }
        this.$engine.routing.config.mqseries.edit(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_edited'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/routing/configurationList/MQSERIES'})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_edition_error'))
        })
      }
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.channelName = this.savedConfig.ChannelName
      this.config.connectionMode = this.savedConfig.ConnectionMode
      this.config.connectionType = this.savedConfig.ConnectionType
      this.config.host = this.savedConfig.Host
      this.config.name = this.savedConfig.Name
      this.config.port = this.savedConfig.Port
      this.config.queueManager = this.savedConfig.QueueManager
      this.config.queueName = this.savedConfig.QueueName
      this.config.sslActive = this.savedConfig.SSL
      //this.config.controlConfig = this.savedConfig.controlConfig
      //this.config.certificateConfig = this.savedConfig.certificateConfig
      //this.config.privateKeysConfig = this.savedConfig.privateKeysConfig
    },
    formHasError () {
      if (this.config.name === undefined || this.config.name.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      if ( this.config.host === undefined || this.config.host.length === 0) {
        this.okMessageBox(this.$t('common.routing.host_missing'))
        return true
      }
      if (this.config.port === undefined || this.config.port.length === 0) {
        this.okMessageBox(this.$t('common.routing.port_missing'))
        return true
      }
      if (this.config.connectionMode === undefined || this.config.connectionMode.length === 0) {
        this.okMessageBox(this.$t('common.routing.connection_mode_missing'))
        return true
      }
      if (this.config.connectionType === undefined || this.config.connectionType.length === 0) {
        this.okMessageBox(this.$t('common.routing.connection_type_missing'))
        return true
      }
      if (this.config.queueManager === undefined || this.config.queueManager.length === 0) {
        this.okMessageBox(this.$t('common.routing.queue_manager_missing'))
        return true
      }
      if (this.config.channelName === undefined || this.config.channelName.length === 0) {
        this.okMessageBox(this.$t('common.routing.channel_name_missing'))
        return true
      }
      if (this.config.queueName === undefined || this.config.queueName.length === 0) {
        this.okMessageBox(this.$t('common.routing.queue_name_missing'))
        return true
      }
      if (this.config.sslActive === undefined || this.config.sslActive !== "0" && this.config.sslActive !== "1") {
        this.okMessageBox(this.$t('common.routing.wrong_ssl_active'))
        return true
      }
      if (this.config.sslActive === "1") { 
        if (this.config.controlConfig === undefined || this.config.controlConfig.selectedVerif.length === 0) {
          this.okMessageBox(this.$t('common.global.ctrl_missing'))
          return true
        }
        if (this.config.certificateConfig === undefined) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.name === undefined || this.config.certificateConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.certificate === undefined || this.config.certificateConfig.certificate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_desc_missing'))
          return true
        }
        if (this.config.certificateConfig.type === undefined || this.config.certificateConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.certif_type_missing'))
          return true
        }
        if (this.config.certificateConfig.password === undefined || this.config.certificateConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.certificateConfig.passwordVerif === undefined || this.config.certificateConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }
        if (this.config.certificateConfig.startDate === undefined || this.config.certificateConfig.startDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_valid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.endDate === undefined || this.config.certificateConfig.endDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_unvalid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.cn === undefined || this.config.certificateConfig.cn.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_cn_missing'))
          return true
        }
        if (this.config.privateKeysConfig === undefined) {
          this.okMessageBox(this.$t('common.securityffff'))
          return true
        }
        if (this.config.privateKeysConfig.name === undefined || this.config.privateKeysConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_name_missing'))
          return true
        }
        if (this.config.privateKeysConfig.privateKey === undefined || this.config.privateKeysConfig.privateKey.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_desc_missing'))
          return true
        }
        if (this.config.privateKeysConfig.type === undefined || this.config.privateKeysConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.priv_key_type_missing'))
          return true
        }
        if (this.config.privateKeysConfig.password === undefined || this.config.privateKeysConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.privateKeysConfig.passwordVerif === undefined || this.config.privateKeysConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }
      }     
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: '/routing/configurationList/MQSERIES'})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
  }
}
</script>


